export default __webpack_public_path__ + "static/media/sign-up-background.be1ba74d.png";